import React, { useEffect, useRef } from "react";
import { BASE_URL, DOMAIN } from "./../../global";
import moment from "moment";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import IconButton from "@mui/material/IconButton";
import { useTheme } from "@mui/material/styles";

import {
  Button,
  TableContainer,
  TextField,
  Autocomplete,
  Box,
  TablePagination,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import SearchIcon from "@mui/icons-material/Search";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import html2pdf from "html2pdf.js";
import DownloadPdfLoaderModal from "../../utils/components/downloadPdfLoader";
import { Table } from "react-bootstrap";
import { showComponent } from "../helper/helpers";
import { companyList } from "../../utils/components/config";

const TextDisplay = ({ text }) => (
  <div style={{ whiteSpace: "pre-wrap" }}>{text?.replace(/\\n/g, "\n")}</div>
);

var form11Columns = [
  {
    id: "id",
    label: "Sr.No.",
    align: "center",
    minWidth: 2,
  },
  {
    id: "typeIdentificationNumber",
    label: "Name of Equipment / Plant",
    align: "left",
    minWidth: 30,
  },
  {
    id: "location",
    label: "Location",
    align: "center",
    minWidth: 15,
  },
  {
    id: "capacity",
    label: "Safe Working Load",
    align: "center",
    minWidth: 10,
  },
  {
    id: "dateOfExamination",
    label: "Last Examined by Whom & Date",
    align: "center",
    minWidth: 20,
  },
  {
    id: "inspectionDate",
    label: "Date of Testing",
    align: "center",
    minWidth: 10,
  },
  {
    id: "certificateValidity",
    label: "Next due Date of Testing",
    align: "center",
    minWidth: 10,
  },
];

var form13Columns = [
  {
    id: "id",
    label: "Sr.No.",
    align: "center",
    minWidth: 2,
  },
  // {
  //   id: "equipment_name",
  //   label: "Name of Equipment",
  //   align: "left",
  //   minWidth: 40,
  // },
  {
    id: "distinctiveNumber",
    label: "Name of Equipment / Plant",
    align: "left",
    minWidth: 24,
  },
  {
    id: "safeWorkingPressure",
    label: "Safe Working Load",
    align: "center",
    minWidth: 10,
  },
  {
    id: "utrasonicTestDate",
    label: "Ultrasonic Examination Date of Testing",
    align: "center",
    minWidth: 10,
  },
  {
    id: "utrasonicNextDueDateCalculate",
    label: "Ultrasonic Next Due Date of Testing",
    align: "center",
    minWidth: 10,
  },
  ,
  // {
  //   id: "internalTestDate",
  //   label: "Internal Examination Date of Testing",
  //   align: "left",
  //   minWidth: 40,
  // },
  // {
  //   id: "internalExaminationDueDate",
  //   label: "Internal Next Due Date of Testing",
  //   align: "left",
  //   minWidth: 40,
  // },
  {
    id: "hydraulicTestDate",
    label: "Hydraulic Examination Date of Testing",
    align: "center",
    minWidth: 10,
  },
  {
    id: "hydraulicNextDueDateCalculate",
    label: "Hydraulic Next Due Date of Testing",
    align: "center",
    minWidth: 10,
  },
  {
    id: "ultrasonicTest",
    label: "Observed Thickness",
    align: "left",
    minWidth: 24,
  },
];

const notNeededColumn = ["id"];

const SummaryList = (props) => {
  const printComponentRef = React.useRef();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [searchBy, setSearchBy] = React.useState("");
  const [searchKey, setSearchKey] = React.useState("");
  const [totalRows, setTotalRows] = React.useState(0);
  const _clientId = localStorage.getItem("clientId");
  const _userType = localStorage.getItem("type");
  const [from, setFrom] = React.useState(null);
  const [to, setTo] = React.useState(null);
  const [finalData, setFinalData] = React.useState([]);
  const [downloadPdfloading, setDownlaodPdfLoading] = React.useState(false);
  const [templateList, setTemplateList] = React.useState([]);
  const [factoryList, setFactoryList] = React.useState([]);
  const [shopsList, setShopsList] = React.useState([]);
  const [selectedIds, setSelectedIds] = React.useState({
    templateId: null,
    factoryId: null,
    shopId: null,
    companyID: null,
  });
  const [showDate, setshowDate] = React.useState("");
 
  const getFormattedDates = (from, to) => {
  const fromDate = moment(from).startOf("day").format("YYYY-MM-DDTHH:mm:ss.SSSZ");
  const toDate = moment(to).endOf("day").format("YYYY-MM-DDTHH:mm:ss.SSSZ");
  return { fromDate, toDate };
  };

  let columns = selectedIds?.templateId == 12 ? form13Columns : form11Columns;
  const getQuery = (count) => {
    let whereConditions = "";
    let pagination_settings = "";

    if (selectedIds?.templateId) {
      whereConditions += ` WHERE reportValues.templateId = ${selectedIds?.templateId} `;
    }

    if (selectedIds?.factoryId) {
      let colName =
        "REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.factoryId'), '\"', '')";
      whereConditions += ` AND ${colName} = ${selectedIds?.factoryId} `;
    }

    // if (selectedIds?.companyID) {
    //   let colName =
    //     "REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.companyName'), '\"', '')";
    //   whereConditions += ` AND ${colName} = ${selectedIds?.companyID} `;
    // }

    if (to != null && from != null) {
      if (whereConditions === "") {
        whereConditions = " WHERE ";
      } else {
        whereConditions += " AND ";
      }

      // Use JSON_EXTRACT to get inspectionDate from JSON
      // whereConditions += ` REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.inspectionDate'), '\"', '') BETWEEN '${moment(
      //   from
      // ).format("YYYY-MM-DD")}' AND '${moment(to).format("YYYY-MM-DD")}' `;
      const { fromDate, toDate } = getFormattedDates(from, to);
      whereConditions += `DATE_ADD(STR_TO_DATE(JSON_UNQUOTE(JSON_EXTRACT(reportValues.templateValues, '$.inspectionDate')),'%Y-%m-%dT%H:%i:%s.000Z'), INTERVAL 0 DAY) between '${fromDate}' and '${toDate}'`;
    }

    if (selectedIds?.shopId) {
      let colName =
        "REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.shopId'), '\"', '')";
      whereConditions += ` AND ${colName} = ${selectedIds?.shopId} `;
    }

    if (rowsPerPage != -1) {
      pagination_settings = `limit ${rowsPerPage} offset ${
        rowsPerPage * Number(page)
      }`;
    }

    // let data = {
    //   query: `SELECT reportValues.templateId, reportValues.id, IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.reportNumber'), '\"', ''), '') AS reportNumber, IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.certificateValidity'), '\"', ''), '') AS certificateValidity, IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.shopId'), '\"', ''), '') AS shopId, IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.reportDate'), '\"', ''), '') AS reportDate, IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.equipmentId'), '\"', ''), '') AS equipmentId, IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.typeIdentificationNumber'), '\"', ''), '') AS typeIdentificationNumber,IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.distinctiveNumber'), '\"', ''), '') AS distinctiveNumber, IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.capacity'), '\"', ''), '') AS capacity, IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.dateOfExamination'), '\"', ''), '') AS dateOfExamination, IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.inspectionDate'), '\"', ''), '') AS inspectionDate, IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.recommendedAfterExamination'), '\"', ''), '') AS recommendedAfterExamination, IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.utrasonicTestDate'), '\"', ''), '') AS utrasonicTestDate, IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.hydraulicTestDate'), '\"', ''), '') AS hydraulicTestDate, IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.internalTestDate'), '\"', ''), '') AS internalTestDate, IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.internalExaminationDueDate'), '\"', ''), '') AS internalExaminationDueDate, IFNULL(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.certificateValidityDate'), '\"', ''), '') AS certificateValidityDate, templates.name, clients.name AS client_name, addresses.address AS client_address, clients.emailId AS client_email, shops.name AS shop_name, products.name AS equipment_name FROM reportValues LEFT JOIN templates ON reportValues.templateId = templates.id LEFT JOIN clients ON JSON_EXTRACT(reportValues.templateValues, '$.factoryId') = clients.id LEFT JOIN addresses ON addresses.id = SUBSTRING_INDEX(clients.address, ',', 1) LEFT JOIN shops ON REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.shopId'), '\"', '') = shops.id LEFT JOIN products ON REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.equipmentId'), '\"', '') = products.id ${whereConditions} ORDER BY id DESC ${pagination_settings}`,
    // };

    let data = {
      query: `SELECT reportValues.templateId, reportValues.id, reportValues.*, REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.ultrasonicTest'), '\"', '') AS ultrasonicTest, REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.companyName'), '\"', '') AS companyName, REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.reportNumber'), '\"', '') AS reportNumber, REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.reportDate'), '\"', '') AS reportDate,DATE_ADD(DATE_ADD(STR_TO_DATE(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.utrasonicTestDate'), '"', ''), '%Y-%m-%d'), INTERVAL 6 MONTH), INTERVAL 1 DAY) AS utrasonicNextDueDateCalculate,DATE_ADD(STR_TO_DATE(REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.hydraulicTestDate'), '\"', ''), '%Y-%m-%d'), INTERVAL 2 YEAR) AS hydraulicNextDueDateCalculate,REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.internalTestDate'), '\"', '') AS internalTestDate,REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.hydraulicTestDate'), '\"', '') AS hydraulicTestDate,REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.utrasonicTestDate'), '\"', '') AS utrasonicTestDate,REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.safeWorkingPressure'), '\"', '') AS safeWorkingPressure,REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.internalExaminationDueDate'), '\"', '') AS internalExaminationDueDate,REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.distinctiveNumber'), '\"', '') AS distinctiveNumber,REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.competentPerson'), '\"', '') AS competentPerson,REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.location'), '\"', '') AS location,REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.typeIdentificationNumber'), '\"', '') AS typeIdentificationNumber,REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.capacity'), '\"', '') AS capacity,REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.dateOfExamination'), '\"', '') AS dateOfExamination,REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.inspectionDate'), '\"', '') AS inspectionDate,
      REPLACE(JSON_EXTRACT(reportValues.templateValues, '$.certificateValidity'), '\"', '') AS certificateValidity, templates.name, clients.name AS client_name, addresses.address AS client_address, clients.emailId AS client_email FROM reportValues LEFT JOIN templates ON reportValues.templateId = templates.id LEFT JOIN clients ON JSON_EXTRACT(reportValues.templateValues, '$.factoryId') = clients.id LEFT JOIN addresses ON addresses.id = SUBSTRING_INDEX(clients.address, ',', 1)
      ${whereConditions}  order by id DESC ${pagination_settings}`,
    };

    if (count)
      data.query = `SELECT COUNT(*) AS no_of_rows FROM reportValues LEFT JOIN templates ON reportValues.templateId = templates.id LEFT JOIN clients ON JSON_EXTRACT(reportValues.templateValues, '$.factoryId') = clients.id LEFT JOIN addresses ON addresses.id = SUBSTRING_INDEX(clients.address, ',', 1) ${whereConditions}`;
    return data;
  };

  // api calls
  function getTotalRows() {
    let data = getQuery(true);

    axiosWithToken
      .post(BASE_URL + `dynamic`, data)
      .then(async (res) => {
        setTotalRows(res.data[0]?.no_of_rows);
      })
      .catch((err) => {
        console.log("datasheet data fetching error: ", err);
      });
  }

  function fetchFinalData() {
    let data = getQuery();

    axiosWithToken
      .post(BASE_URL + `dynamic`, data)
      .then((res) => {
        setFinalData(res.data);
      })
      .catch((err) => {
        console.log("  error: ", err);
      });
  }
  const [competentPerson, setcompetentPerson] = React.useState([]);
  function fetchCompnetentData() {
    axiosWithToken
      .get(BASE_URL + `competents`)
      .then((res) => {
        const ids = finalData
          .map((data) => data.competentPerson)
          .filter((value, index, self) => self.indexOf(value) === index);
        const filteredCompetentPersons = res.data.filter((cp) =>
          ids.includes(cp.id.toString())
        );
        setcompetentPerson(filteredCompetentPersons[0]);
      })
      .catch((err) => {
        console.log("  error: ", err);
      });
  }

  const search = () => {
    fetchFinalData();
    getTotalRows();
  };

  const generatePDF = async () => {
    setDownlaodPdfLoading(true);
    try {
      const element = printComponentRef.current;
      let pdf = await html2pdf()
        .from(element)
        .set({
          margin: [8, 1, 10, 1],
          filename: `masterInOut.pdf`,
          pagebreak: { after: "section", mode: ["css", "legacy"] },
          html2canvas: {
            dpi: 192,
            scale: 4,
            letterRendering: true,
            useCORS: true,
          },
          image: { type: "png", quality: 0.4 },
          jsPDF: {
            orientation: "portrait",
            unit: "pt",
            format: "a4",
            compress: true,
          },
        })
        .toPdf()
        .get("pdf");

      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        pdf.setFontSize(9);
        pdf.setTextColor(0, 0, 0);
        pdf.setFont("helvetica", "bold");

        // border add for contnet
        const borderWidth = 0.6;
        const leftMargin = 6;
        const borderX = leftMargin;
        const borderY = 5;
        const rightMargin = 595 - leftMargin * 0.95;
        pdf.setLineWidth(borderWidth);
        pdf.rect(borderX, borderY, rightMargin - leftMargin, 830);
      }

      const blob = pdf.output("blob");
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `summaryReport.pdf`;
      a.click();

      setDownlaodPdfLoading(false);
    } catch (error) {
      console.error("Error generating PDF:", error);
      setDownlaodPdfLoading(false);
    }
  };

  const getAllTemplate = () => {
    axiosWithToken
      .get(BASE_URL + `templates`)
      .then((res) => {
        setTemplateList(res.data);
      })
      .catch((err) => {
        console.log(" error: ", err);
      });
  };

  const getAllFactory = () => {
    axiosWithToken
      .get(BASE_URL + `clients`)
      .then((res) => {
        setFactoryList(res.data);
      })
      .catch((err) => {
        console.log(" error: ", err);
      });
  };

  const getAllShops = () => {
    axiosWithToken
      .get(BASE_URL + `shops`)
      .then((res) => {
        setShopsList(res.data);
      })
      .catch((err) => {
        console.log(" error: ", err);
      });
  };

  var refresh = () => {
    window.location.reload(false);
  };

  useEffect(() => {
    getAllTemplate();
    getAllFactory();
    getAllShops();
  }, []);

  useEffect(() => {
    fetchCompnetentData();
  }, [finalData]);

  useEffect(() => {
    fetchFinalData();
    getTotalRows();
  }, [rowsPerPage, page]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const TablePaginationActions = (props) => {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    );
  };

  return (
    <div>
      <div style={{ margin: "5px", padding: "5px" }}>
        <div
          className="mb-2"
          style={{
            display: "flex",
            float: "left",
            justifyContent: "flex-end",
          }}
        >
          {/* <Autocomplete
            sx={{
              m: 0,
              minWidth: 180,
              marginLeft: "10px",
            }}
            size="small"
            onChange={(event, newValue) => {
              setSelectedIds((prevState) => ({
                ...prevState,
                companyID: newValue ? newValue.id : null,
              }));
            }}
            options={companyList}
            getOptionLabel={(option) => option.label}
            renderInput={(params) => (
              <TextField {...params} label="Select Company Name" />
            )}
          /> */}

          <Autocomplete
            sx={{
              m: 0,
              minWidth: 140,
              marginLeft: "10px",
            }}
            size="small"
            onChange={(event, newValue) => {
              setSelectedIds((prevState) => ({
                ...prevState,
                templateId: newValue ? newValue.id : null,
              }));
            }}
            options={templateList}
            getOptionLabel={(option) => option.name}
            renderInput={(params) => (
              <TextField {...params} label="Select Form Type" />
            )}
          />

          <Autocomplete
            sx={{
              m: 0,
              minWidth: 180,
              marginLeft: "10px",
            }}
            size="small"
            onChange={(event, newValue) => {
              setSelectedIds((prevState) => ({
                ...prevState,
                factoryId: newValue ? newValue.id : null,
              }));
            }}
            options={factoryList}
            getOptionLabel={(option) => option.name}
            renderInput={(params) => (
              <TextField {...params} label="Select Factory" />
            )}
          />

          {/* <Autocomplete
            sx={{
              m: 0,
              minWidth: 180,
              marginLeft: "10px",
            }}
            size="small"
            onChange={(event, newValue) => {
              setSelectedIds((prevState) => ({
                ...prevState,
                shopId: newValue ? newValue.id : null,
              }));
            }}
            options={shopsList}
            getOptionLabel={(option) => option.name}
            renderInput={(params) => (
              <TextField {...params} label="Select Shop" />
            )}
          /> */}

          <div
            style={{ marginLeft: "10px", marginRight: "10px" }}
            id="quotationlist_datefrom"
          >
            <LocalizationProvider
              dateAdapter={AdapterDateFns}
              classNames="mr-2"
            >
              <DatePicker
              sx={{width:"200px"}}
                slotProps={{ textField: { size: "small", fullWidth: true } }}
                label="From"
                value={from ? new Date(from) : ""}
                inputFormat="dd/MM/yyyy"
                format="dd/MM/yyyy"
                onChange={(newValue) => setFrom(newValue)}
                renderInput={(params) => <TextField {...params} size="small" />}
              />
            </LocalizationProvider>
          </div>

          <div style={{ marginRight: "10px" }} id="quotationlist_dateto">
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <DatePicker
              sx={{width:"200px"}}
              slotProps={{ textField: { size: "small", fullWidth: true } }}
                label="To"
                value={to ? new Date(to) : ""}
                inputFormat="dd/MM/yyyy"
                format="dd/MM/yyyy"
                onChange={(newValue) => setTo(newValue)}
                renderInput={(params) => <TextField {...params} size="small" />}
                style={{ marginRight: "20px" }}
              />
            </LocalizationProvider>
          </div>

          <Button
            variant="contained"
            size="small"
            sx={{ m: 0 }}
            style={{ marginLeft: "10px" }}
            onClick={() => {
              search();
            }}
          >
            <SearchIcon />
          </Button>

          <Button
            variant="contained"
            size="small"
            sx={{ height: "40px", marginLeft: "10px" }}
            onClick={() => {
              generatePDF();
            }}
          >
            Download PDF
          </Button>
        </div>

        {/* <div
          className="mb-2"
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "flex-end",
          }}
        >
          <Button
            variant="contained"
            size="small"
            sx={{ height: "40px", marginLeft: "10px" }}
            onClick={() => {
              generatePDF();
            }}
          >
            Download PDF
          </Button>
        </div> */}
      </div>
      <TableContainer component={Paper} sx={{ mt: 2, p: 2 }}>
        <div style={{ width: "98%", margin: "auto" }} ref={printComponentRef}>
          {/* {companyList.find(
            (company) => company.id === selectedIds.companyID
          ) && (
            <div
              style={{ borderBottom: "1px solid black", textAlign: "center" }}
            >
              <h4>
                <b>
                  {
                    companyList.find(
                      (company) => company.id == selectedIds.companyID
                    ).label
                  }
                </b>
              </h4>
              <h6 style={{ fontSize: "16px", marginBottom: "5px" }}>
                {
                  companyList.find(
                    (company) => company.id == selectedIds.companyID
                  ).address
                }
              </h6>
            </div>
          )} */}
          <div style={{ padding: "0px 5px" }}>
            <div style={{ padding: "10px" }}>
              <div style={{ textAlign: "center" }}>
                <h4 style={{ fontSize: "21px", fontWeight: "bold" }}>INDEX</h4>
                <h6>
                  {selectedIds?.templateId == 13
                    ? "INSPECTION DETAILS OF TESTING OF HOIST, LIFT & LIFTING MACHINERY"
                    : "INSPECTION DETAILS OF TESTING OF PRESSURE VESSELS / PRESSURE PLANTS"}
                </h6>
              </div>
              <div
                id="summaryBorder"
                style={{
                  textAlign: "left",
                  fontWeight: "bold",
                  fontSize: "13px",
                  marginTop: "5px",
                }}
              >
                <table>
                  <tbody>
                    <tr>
                      <td
                        style={{
                          fontSize: "13px",
                          verticalAlign: "top",
                          border: "none",
                          padding: "3px 0px",
                          width: "50%",
                        }}
                      >
                        Place of Inspection{" "}
                      </td>
                      <td
                        style={{
                          fontSize: "13px",
                          verticalAlign: "top",
                          border: "none",
                          padding: "3px 0px",
                          width: "2%",
                        }}
                      >
                        :
                      </td>
                      <td
                        style={{
                          fontSize: "13px",
                          verticalAlign: "top",
                          border: "none",
                          padding: "3px 0px",
                          width: "48%",
                          fontWeight: 100,
                        }}
                      >
                        {finalData?.[0]?.client_name} <br />{" "}
                        {finalData?.[0]?.client_address}
                      </td>
                    </tr>
                    {/* {from && to && ( */}
                    <tr>
                      <td
                        style={{
                          fontSize: "13px",
                          verticalAlign: "top",
                          border: "none",
                          padding: "3px 0px",
                          width: "50%",
                        }}
                      >
                        Date Of Inspection{" "}
                      </td>
                      <td
                        style={{
                          fontSize: "13px",
                          verticalAlign: "top",
                          border: "none",
                          padding: "3px 0px",
                          width: "2%",
                        }}
                      >
                        :
                      </td>
                      <td
                        style={{
                          fontSize: "13px",
                          verticalAlign: "top",
                          border: "none",
                          padding: "3px 0px",
                          width: "48%",
                          fontWeight: 100,
                        }}
                      >
                        {!downloadPdfloading ? (
                          <TextField
                            size="small"
                            variant="standard"
                            value={showDate || ""}
                            onChange={(e) => setshowDate(e.target.value)}
                          />
                        ) : (
                          <span>{showDate}</span>
                        )}
                        {/* {from && to && (
                        <span>
                          {moment(from).format("DD-MM-YYYY")} to{" "}
                          {moment(to).format("DD-MM-YYYY")}
                        </span>
                      )} */}
                      </td>
                    </tr>
                    {/* )} */}
                    {/* {shopsList.find((el) => el.id == selectedIds?.shopId)
                      ?.name && (
                      <tr>
                        <td
                          style={{
                            fontSize: "13px",
                            verticalAlign: "top",
                            border: "none",
                            padding: "3px 0px",
                            width: "50%",
                          }}
                        >
                          Shop/Plant{" "}
                        </td>
                        <td
                          style={{
                            fontSize: "13px",
                            verticalAlign: "top",
                            border: "none",
                            padding: "3px 0px",
                            width: "2%",
                          }}
                        >
                          :
                        </td>
                        <td
                          style={{
                            fontSize: "13px",
                            verticalAlign: "top",
                            border: "none",
                            padding: "3px 0px",
                            width: "48%",
                            fontWeight: 100,
                          }}
                        >
                          {
                            shopsList.find((el) => el.id == selectedIds?.shopId)
                              ?.name
                          }
                        </td>
                      </tr>
                    )} */}
                    <tr>
                      <td
                        style={{
                          fontSize: "13px",
                          verticalAlign: "top",
                          border: "none",
                          padding: "3px 0px",
                          width: "50%",
                        }}
                      >
                        Name Of Competent Person{" "}
                      </td>
                      <td
                        style={{
                          fontSize: "13px",
                          verticalAlign: "top",
                          border: "none",
                          padding: "3px 0px",
                          width: "2%",
                        }}
                      >
                        :
                      </td>
                      <td
                        style={{
                          fontSize: "13px",
                          verticalAlign: "top",
                          border: "none",
                          padding: "3px 0px",
                          width: "48%",
                          fontWeight: 100,
                        }}
                      >
                        {competentPerson?.personName}
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          fontSize: "13px",
                          verticalAlign: "top",
                          border: "none",
                          padding: "3px 0px",
                          width: "50%",
                        }}
                      >
                        Section Rule{" "}
                      </td>
                      <td
                        style={{
                          fontSize: "13px",
                          verticalAlign: "top",
                          border: "none",
                          padding: "3px 0px",
                          width: "2%",
                        }}
                      >
                        :
                      </td>
                      <td
                        style={{
                          fontSize: "13px",
                          verticalAlign: "top",
                          border: "none",
                          padding: "3px 0px",
                          width: "48%",
                          fontWeight: 100,
                        }}
                      >
                        {selectedIds?.templateId == 13
                          ? "Section 28/29 & Rule 62/64 of MFR 1963."
                          : "Section 31 & Rule 65 of MFR 1963"}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <table
              // stickyHeader
              aria-label="sticky table"
              size="small"
              style={{ borderCollapse: "collapse", width: "100%" }}
            >
              <thead id="singlebordertable">
                <tr>
                  {columns.map((column, index) => (
                    <th
                      key={column.id}
                      style={{
                        width: `${column.minWidth}%`,
                        fontSize: "12px",
                        padding: "5px",
                        textAlign: column.align,
                      }}
                    >
                      <b>{column.label}</b>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody id="singlebordertable">
                {finalData?.length > 0 ? (
                  finalData
                    ?.sort((a, b) => a.id - b.id)
                    ?.map((row, index) => {
                      return (
                        <tr
                          id="pagbreaksborder"
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={index}
                        >
                          {columns.map((column, columnIndex) => {
                            let value;

                            if (
                              column.id === "typeIdentificationNumber" ||
                              column.id === "distinctiveNumber" ||
                              column.id === "ultrasonicTest"
                            ) {
                              value = row[column.id] || "";
                              return (
                                <td
                                  style={{
                                    fontSize:
                                      column.id == "ultrasonicTest"
                                        ? "10px"
                                        : "11px",
                                    padding: "5px",
                                    width: "20px",
                                  }}
                                  key={column.id}
                                  align={column.align}
                                >
                                  <TextDisplay text={value} />
                                </td>
                              );
                            } else if (columnIndex === 1) {
                              // Special handling for the column with index 1
                              const value1 = row["equipment_name"] || "";
                              const value2 = row[columns[1].id] || "";
                              const mergedValue = `${value1} ,  ${value2}`;
                              return (
                                <td
                                  style={{
                                    fontSize: "12px",
                                    padding: "5px",
                                    width: "20px",
                                  }}
                                  key={column.id}
                                  align={column.align}
                                >
                                  {mergedValue}
                                </td>
                              );
                            } else {
                              if (
                                column.id === "certificateValidity" ||
                                column.id === "inspectionDate" ||
                                column.id === "hydraulicTestDate" ||
                                // column.id === "internalTestDate" ||
                                column.id === "utrasonicNextDueDateCalculate" ||
                                column.id === "hydraulicNextDueDateCalculate" ||
                                column.id === "utrasonicTestDate"
                              ) {
                                let newDate = moment(row[column.id]).format(
                                  "DD-MM-YYYY"
                                );
                                value = row[column.id] ? newDate : null;
                              } else {
                                value = row[column.id];
                              }
                              if (column.id === "id") {
                                value = page * rowsPerPage + index + 1;
                              }
                              return (
                                <td
                                  style={{
                                    fontSize: "12px",
                                    padding: "5px",
                                    width: "20px",
                                  }}
                                  key={column.id}
                                  align={column.align}
                                >
                                  {column.format && typeof value === "number"
                                    ? column.format(value)
                                    : value}
                                </td>
                              );
                            }
                          })}
                        </tr>
                      );
                    })
                ) : (
                  <tr>
                    <td colSpan={columns.length + 1}>
                      <h6>
                        <b>Data Not Found</b>
                      </h6>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <div style={{ pageBreakInside: "avoid" }}>
              {companyList.find(
                (company) => company.id === selectedIds.companyID
              ) && (
                <div
                  style={{
                    textAlign: "right",
                    marginRight: "7rem",
                    padding: "15px 0px 5px",
                  }}
                >
                  <h6>
                    <b>
                      For{" "}
                      {
                        companyList.find(
                          (company) => company.id == selectedIds.companyID
                        ).label
                      }
                    </b>
                  </h6>
                </div>
              )}
              {competentPerson && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "30%",
                      textAlign: "center",
                      alignItems: "center",
                    }}
                  >
                    <img
                      src={competentPerson?.signPath}
                      alt="sign"
                      style={{ height: "50px", width: "180px" }}
                    />
                    <p style={{ fontSize: "0.7rem", color: "black" }}>
                      <b>{competentPerson?.personName}</b>
                    </p>
                    <p style={{ fontSize: "0.7rem", color: "black" }}>
                      <b>
                        {" "}
                        <TextDisplay text={competentPerson?.qualification} />
                      </b>
                    </p>
                  </div>
                  <div>
                    <img
                      src={competentPerson?.stampPath}
                      alt="sign"
                      style={{ height: "110px" }}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50]}
          count={totalRows}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          component="div"
          colSpan={3}
          SelectProps={{
            inputProps: {
              "aria-label": "rows per page",
            },
            native: true,
          }}
          ActionsComponent={TablePaginationActions}
        />
      </TableContainer>
      {downloadPdfloading && (
        <DownloadPdfLoaderModal
          loading={downloadPdfloading}
          name={"Summary Report"}
        />
      )}
    </div>
  );
};

export default SummaryList;
